import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE = createFcmDetails(
	'psf_share_initial_above_button_message',
	{
		owner: 'TBD',
		context: 'PSF share page',
		description: 'Displays a warning above the share links',
		import: false,
	},
);
